import { Box, Button, CircularProgress, Typography } from '@mui/material'
import { declineInvite } from 'api/careTeams'
import { useAuthContext } from 'components/context/AuthProvider'
import { AddSubscriptionHeader } from 'features/Subscription/components/AddSubscriptionHeader'
import { useQuery } from 'react-query'
import { Navigate, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { routes } from 'routes/routes'
import { AuthCopyright } from '../AuthCopyright/AuthCopyright'

export const AuthPageDeclineInvite = () => {
  const [searchParams] = useSearchParams()
  const inviteToken = searchParams.get('invite')
  const navigate = useNavigate()
  const location = useLocation()
  const { checkIsLoggedIn } = useAuthContext()
  const isLoggedIn = checkIsLoggedIn()

  const { isLoading, isSuccess, isError } = useQuery(
    ['declineInvite', inviteToken],
    () => declineInvite(inviteToken ?? ''),
    { enabled: !!inviteToken && isLoggedIn },
  )

  const handleGoToHome = () => {
    navigate(isLoggedIn ? routes.journey : routes.signIn)
  }

  if (inviteToken && !isLoggedIn) {
    const currentUrl = `${location.pathname}${location.search}`
    return <Navigate to={`${routes.signIn}?redirect=${encodeURIComponent(currentUrl)}`} replace />
  }

  return (
    <>
      {isLoggedIn && <AddSubscriptionHeader />}
      <Box
        display="flex"
        flexDirection="column"
        height="100vh"
        alignItems="center"
        justifyContent="center"
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          flex={1}
        >
          {!inviteToken && (
            <>
              <Typography variant="h5" textAlign="center" color="error.main" mb={3}>
                Invalid invitation link. Please check the link and try again.
              </Typography>
              <Button variant="contained" onClick={handleGoToHome} sx={{ minWidth: 160 }}>
                Go to Home
              </Button>
            </>
          )}

          {isLoading && (
            <>
              <CircularProgress size={48} />
              <Typography variant="body1" color="text.secondary" mt={2}>
                Declining the invitation...
              </Typography>
            </>
          )}

          {isSuccess && (
            <>
              <Typography variant="h5" textAlign="center" color="text.primary" mb={3}>
                You have declined the invitation.
              </Typography>
              <Button variant="contained" onClick={handleGoToHome} sx={{ minWidth: 160 }}>
                Go to Home
              </Button>
            </>
          )}

          {isError && (
            <>
              <Typography variant="h5" textAlign="center" color="error.main" mb={3}>
                Failed to decline the invitation. The link may have expired or already been used.
              </Typography>
              <Button variant="contained" onClick={handleGoToHome} sx={{ minWidth: 160 }}>
                Go to Home
              </Button>
            </>
          )}
        </Box>

        <Box mt="auto" mb={3}>
          <AuthCopyright />
        </Box>
      </Box>
    </>
  )
}
